import { useCallback, useRef, useState } from "react";

let localFileSequence = 0;
const generateFileId = () => `local-file-${Date.now()}-${localFileSequence++}`;
const useWageDocuments = (initialFiles = []) => {
  const normalize = files => (files || []).map(file => ({ ...file, isNew: false }));

  const lastServerFilesRef = useRef(normalize(initialFiles));
  const [wageDocumentsState, setWageDocumentsState] = useState({
    files: lastServerFilesRef.current,
    removedFileIds: []
  });
  const syncFromServer = useCallback(files => {
    const normalized = normalize(files);
    lastServerFilesRef.current = normalized;
    setWageDocumentsState({ files: normalized, removedFileIds: [] });
  }, []);

  const discardChanges = useCallback(() => {
    setWageDocumentsState({ files: lastServerFilesRef.current, removedFileIds: [] });
  }, []);

  const addFile = useCallback(file => {
    const newFile = {
      id: generateFileId(),
      name: file.name,
      label: "",
      size: file.size,
      uploadedDate: new Date().toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }),
      uploadedBy: "",
      file,
      isNew: true
    };

    setWageDocumentsState(prev => ({ ...prev, files: [newFile, ...prev.files] }));
  }, []);

  const changeLabel = useCallback((fileId, label) => {
    setWageDocumentsState(prev => ({
      ...prev,
      files: prev.files.map(item => (item.id === fileId ? { ...item, label } : item))
    }));
  }, []);

  const deleteFile = useCallback(fileId => {
    setWageDocumentsState(prev => {
      const fileToRemove = prev.files.find(item => item.id === fileId);
      const files = prev.files.filter(item => item.id !== fileId);
      const removedFileIds =
        fileToRemove && !fileToRemove.isNew ? [...prev.removedFileIds, fileId] : prev.removedFileIds;
      return { files, removedFileIds };
    });
  }, []);

  return { wageDocumentsState, addFile, changeLabel, deleteFile, syncFromServer, discardChanges };
};

export default useWageDocuments;